<template>
  <div class="container mb-4">
    <h1>
      OOYYO Annual reports for the last 5 years
    </h1>
    <div class="text-muted">Click on image to view the report</div>
    <div class="row">
      <div v-for="year in years" :key="year" class="col-12 col-md-6 mb-4">
        <a :href="`${root}/OOYYO_${year}_Annual_Report.pdf`" target="_blank">
          <img :src="`${root}/${year}.png`" class="w-100 rounded-3 border shadow-lg">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: [2021, 2020, 2019, 2018, 2017],
      root: "https://d10y2oj5s0rxih.cloudfront.net/reports"
    }
  }
};
</script>
